import {
  faGauge,
  faUsers,
  faGear,
  faShoppingBag,
  faBasketShopping,
  faLock,
  faList,
  faClock,
  faUser,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";

export const adminNavLinks = [
  {
    label: "Dashboard",
    href: "/app",
    icon: faGauge,
    pageTitle: "Dashboard",
    // no permission → always visible
  },
  {
    label: "Manage customers",
    href: "/app/customers",
    icon: faUsers,
    pageTitle: "Manage Customers",
    permission: ["manage_user_account", "read_user_account"],
  },
  {
    label: "Manage products",
    href: "/app/products",
    icon: faShoppingBag,
    pageTitle: "Manage Products",
    permission: ["manage_product", "read_product"],
  },
  {
    label: "Manage Shops",
    href: "/app/shops",
    icon: faBasketShopping,
    pageTitle: "Manage Shops",
    permission: ["manage_shop_modules", "manage_shop", "read_shop"],
  },
  {
    label: "Settings",
    icon: faGear,
    pageTitle: "Settings",
    children: [
      {
        label: "Manage permissions",
        href: "/app/permissions",
        icon: faShieldAlt,
        pageTitle: "Manage Permissions",
        permission: [
          "manage_permission",
          "read_permission",
          "manage_assign_permission",
        ],
      },
      {
        label: "Change password",
        href: "/app/changePassword",
        icon: faLock,
        pageTitle: "Change Password",
        // no permission → always visible
      },
      {
        label: "Manage Users",
        icon: faUsers,
        desc: "Access user management settings including logs and permissions",
        // no permission on parent → shows if any child is visible
        children: [
          {
            label: "Users list",
            href: "/app/users",
            icon: faList,
            desc: "Display list of all users",
            permission: ["manage_user_account", "read_user_account"],
          },
          {
            label: "User logs",
            href: "/app/userLogs",
            icon: faClock,
            desc: "View system logs related to users",
            permission: ["read_user_logs", "read_user_activity_logs"],
          },
        ],
      },

      {
        label: "My profile",
        href: "/app/profile",
        icon: faUser,
        pageTitle: "My Profile",
        // no permission → always visible
      },
    ],
  },
];

export function getPageTitle(pathname) {
  for (const link of adminNavLinks) {
    if (link.children) {
      for (const child of link.children) {
        if (child.children) {
          for (const grandchild of child.children) {
            if (
              pathname === grandchild.href ||
              (grandchild.href && pathname.startsWith(grandchild.href))
            ) {
              return grandchild.label;
            }
          }
        }
        if (
          child.href &&
          (pathname === child.href || pathname.startsWith(child.href))
        ) {
          return child.pageTitle ?? child.label;
        }
      }
    }
    if (link.href && pathname === link.href) return link.pageTitle;
    if (link.href && link.href !== "/app" && pathname.startsWith(link.href))
      return link.pageTitle;
  }
  return "Dashboard";
}